import axios from "axios";
import AddProjectStore from "../../../store/AddProjectStore";
import {
  GET_WHITELABEL,
  POST_WHITELABEL_LOGIN,
} from "../../../services/constants";

const payload = {
  header_logo: null,
  show_translation: true,
  show_upgrade: true,
  show_affiliate: true,
  show_header_links: true,
  show_header_custom_links: false,
  header_custom_links: [],
  theme_color: null,
  theme_color_list: [],
  show_footer_links: true,
  show_footer_custom_links: false,
  custom_links: [],
  favicon: null,
};

const handleWhiteLabelReset = () => {
  AddProjectStore.setState({
    whitelable_loaded: true,
    appliedWhiteLable: payload,
    white_lable: {
      isUpdate: false,
      ...payload,
    },
  });
};

const handleWhiteLabelUpdate = (data) => {
  const labelData = data.data[0];
  AddProjectStore.setState({
    whitelable_loaded: true,
    appliedWhiteLable: {
      ...labelData,
      id: data.id || null,
      favicon: data.fav_icon || null,
      header_logo: data.header || null,
    },
    white_lable: {
      ...labelData,
      favicon: {
        src: data.fav_icon || null,
        type: null,
      },
      header_logo: {
        src: data.header || null,
        type: null,
      },
    },
  });
};

export const fetchAndApplyWhiteLabel = async (email) => {
  const domain = window.location.hostname;
  const config = {
    email,
    domain,
  };
  try {
    const resp = await axios.get(GET_WHITELABEL(config));
    const data = resp.data?.[0];

    if (data?.data?.[0]) {
      handleWhiteLabelUpdate(data);
    } else {
      handleWhiteLabelReset();
    }
  } catch (error) {
    console.error("White label fetch failed:", error);
    handleWhiteLabelReset();
  }
};

export const fetchAndApplyWhiteLabelOffline = async (domain) => {
  if (domain === "app.rankspro.io") return;
  try {
    const resp = await axios.post(POST_WHITELABEL_LOGIN(), {
      domain,
    });
    const data = resp.data?.[0];
    if (data?.data?.[0]) {
      handleWhiteLabelUpdate(data);
    } else {
      handleWhiteLabelReset();
    }
  } catch (error) {
    console.error("White label fetch failed:", error);
    handleWhiteLabelReset();
  }
};
